const SearchInput = ({
  value,
  searchRef,
  containerRef,
  onChange,
  onSearch,
  placeholder = "Search...",
  onKeyDown,
  onKeyPress,
  onFocus,
}) => {
  return (
    <div className="input-group" ref={containerRef}>
      <input
        type="text"
        name="search"
        ref={searchRef}
        onKeyPress={onKeyPress}
        className="form-control"
        value={value}
        onChange={onChange} // send full event back
        autoComplete="off"
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        // autoFocus
      />
      <button
        className={`input-group-text ${value.trim() ? "bg-label-prime" : ""}`}
        // disabled={!value.trim()}
        onClick={onSearch}
      >
        <i className={`bx ${value.trim() ? "bx-plus" : "bx-search"}`}></i>
      </button>
    </div>
  );
};

export default SearchInput;
